<template>
  <div class="subscription-unlock">
    <div v-if="showVideo && getByKey('videos.checkout_video', true)" class="text-center">
      <video controls width="450px" class="casual-border-radius mx-auto mb-3 border-video-player" style="max-width: 100%; min-height: 200px;">
        <source :src="getByKey('videos.checkout_video', true)" />
      </video>
    </div>

    <ModernAlert v-if="hasLegacySubscription" variant="warning">
      <div v-html="getByKey('pricing.legacySubscriptionWarning')" />
    </ModernAlert>

    <ModernAlert v-if="hasMultipleLegacySubscriptions" variant="error">
      <div v-html="$t('billing.subscriptions.multipleLegacySubscriptionsNotice')" />
    </ModernAlert>

    <div class="pricing-grid">
      <pricing-card
        v-for="product in productVariations"
        :key="product.key"
        :product="product"
        :default-interval="currentInterval"
        :available-intervals="availableIntervals"
        :disabled="hasMultipleLegacySubscriptions"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PricingCard from "./PricingCard.vue";
import ModernAlert from "@/components/elements/ModernAlert.vue";
import ServerContentMixin from "@/mixins/ServerContentMixin";

export default {
  components: { PricingCard, ModernAlert },
  mixins: [ServerContentMixin],

  data() {
    return {
      showVideo: false,
    }
  },

  mounted() {
    setTimeout(() => {
      this.showVideo = true;
    }, 1000);
  },

  computed: {
    ...mapState({
      products: (state) => state.checkout.products,
      subscriptions: (state) => state.account.subscriptions,
    }),

    productVariations() {
      return this.products.subscriptions
        .filter((x) => x.groupId === "core")
        .sort((a, b) => a.order - b.order);
    },

    availableIntervals() {
      const order = [2, 0]; // Quarterly first, Yearly second
      return order;
    },

    hasLegacySubscription() {
      return this.subscriptions.some((sub) => sub.products?.some((x) => x.isLegacy));
    },

    hasMultipleLegacySubscriptions() {
      const subs = this.subscriptions
        .filter((sub) => sub.products?.some((x) => x.isLegacy))
        .reduce((acc, sub) => {
          acc += sub.plans.length;
          return acc;
        }, 0);
      return subs > 1;
    },

    currentSubscription() {
      const nonLegacyKeys = this.products.subscriptions
        .filter((x) => !x.isLegacy)
        .map((x) => x.key);
      return this.subscriptions.find((sub) =>
        sub.products?.some((p) => nonLegacyKeys.includes(p.key))
      );
    },

    currentInterval() {
      if (!this.currentSubscription?.plans?.length) return 0;
      const plans = this.currentSubscription.plans;

      for (const product of this.productVariations) {
        for (const [intervalKey, intervalData] of Object.entries(product.intervals)) {
          if (plans.includes(intervalData.stripePriceId)) {
            return Number(intervalKey);
          }
        }
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/globals/_variables.scss";

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  row-gap: 2.5rem;
  padding-top: 0.25rem;
  padding-bottom: 1.25rem;

  @media (max-width: 1300px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    row-gap: 1.5rem;
  }
}

</style>
